interface Props {
  [key: string]: any
}

export default function HomClockIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 15 15" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5837 7.5C14.5837 11.4118 11.4121 14.5833 7.50033 14.5833C3.58855 14.5833 0.416992 11.4118 0.416992 7.5C0.416992 3.58823 3.58855 0.416668 7.50033 0.416668C11.4121 0.416668 14.5837 3.58823 14.5837 7.5Z"
        fill="#7D38D6"
      />
      <path
        d="M7.50033 13.5208C10.8255 13.5208 13.5212 10.8252 13.5212 7.5C13.5212 4.17479 10.8255 1.47917 7.50033 1.47917C4.17511 1.47917 1.47949 4.17479 1.47949 7.5C1.47949 10.8252 4.17511 13.5208 7.50033 13.5208Z"
        fill="#B177BF"
      />
      <path
        d="M7.75237 7.60165C7.7042 7.55349 7.67445 7.48726 7.67481 7.41394C7.67481 7.26732 7.79381 7.14832 7.94043 7.14832H12.1904C12.3371 7.14832 12.4561 7.26732 12.4561 7.41394C12.4561 7.56057 12.3371 7.67957 12.1904 7.67957L7.94043 7.67922C7.86677 7.67957 7.80054 7.64982 7.75237 7.60165Z"
        fill="white"
      />
      <path
        d="M7.1149 7.69692C7.05328 7.67885 6.99484 7.64733 6.94384 7.60129L4.6708 5.55456C4.48911 5.39058 4.47459 5.11115 4.63822 4.9291C4.80149 4.74742 5.08163 4.73183 5.26332 4.89652L7.53636 6.94325C7.71805 7.10723 7.73257 7.38667 7.56895 7.56871C7.45136 7.69904 7.27322 7.74367 7.1149 7.69692Z"
        fill="white"
      />
      <path
        d="M7.50033 8.20833C7.89153 8.20833 8.20866 7.8912 8.20866 7.5C8.20866 7.1088 7.89153 6.79167 7.50033 6.79167C7.10912 6.79167 6.79199 7.1088 6.79199 7.5C6.79199 7.8912 7.10912 8.20833 7.50033 8.20833Z"
        fill="#7D38D6"
      />
    </svg>
  )
}
